import { onSignalREvent } from '../../signalRBus'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import type { MessageUnreadSignalRPayload } from 'src/signalR/types'
import { useMessagingServiceStore } from 'src/stores/messaging.service.store'
import { useAuthStore } from 'src/common/store'

onSignalREvent(
  SIGNAL_R_SCOPES.message,
  SIGNAL_R_MESSAGES.messageUnread,
  (text, response) => {
    const payload: MessageUnreadSignalRPayload = JSON.parse(text)
    const messagingServiceStore = useMessagingServiceStore()
    const authStore = useAuthStore()
    if (
      response.CenterId &&
      response.CenterId !== authStore.currentCenterId &&
      !authStore.isClient
    ) {
      return
    }
    messagingServiceStore.handleMessageUnreadEvent(payload)
  },
)
